module.exports = __webpack_public_path__ + "img/78147e8.webp";